import {
  REQUEST_CREATE_EXPERTISE_VICTIM,
  REQUEST_GET_EXPERTISE_VICTIM,
  REQUEST_SET_EXPERTISE_VICTIM,
  REQUEST_CREATE_MISSION_POSTPONE,
  REQUEST_GET_MISSION_POSTPONE,
  REQUEST_SET_MISSION_POSTPONE,
  REQUEST_GET_MISSION_POSTPONE_EXPERTISE,
  REQUEST_SET_MISSION_POSTPONE_EXPERTISE,
  REQUEST_UPDATE_MISSION_EXPERTISE,
  REQUEST_UPDATE_MISSION_POSTPONE,
  REQUEST_REJECT_MISSION,
  RESET_STORE_DETAILS_EXPERTISE,
} from 'containers/ExpertExpertise/constants';

export const requestCreateExpertiseVictim = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_CREATE_EXPERTISE_VICTIM,
  payload,
  successCallback,
});
export const requestGetExpertiseVictim = (payload: any) => ({
  type: REQUEST_GET_EXPERTISE_VICTIM,
  payload,
});
export const setExpertiseVictim = (payload: any) => ({
  type: REQUEST_SET_EXPERTISE_VICTIM,
  payload,
});
export const requestCreateMissionPostPone = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_CREATE_MISSION_POSTPONE,
  payload,
  successCallback,
});

export const requestGetMissionPostPone = (payload: any) => ({
  type: REQUEST_GET_MISSION_POSTPONE,
  payload,
});
export const setMissionPostPone = (payload: any) => ({
  type: REQUEST_SET_MISSION_POSTPONE,
  payload,
});
export const requestGetMissionPostPoneExpertise = (payload: any) => ({
  type: REQUEST_GET_MISSION_POSTPONE_EXPERTISE,
  payload,
});
export const setMissionPostPoneExpertise = (payload: any) => ({
  type: REQUEST_SET_MISSION_POSTPONE_EXPERTISE,
  payload,
});
export const requestUpdateMissionExpertise = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_MISSION_EXPERTISE,
  payload,
  successCallback,
});
export const requestUpdateMissionPostPone = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_MISSION_POSTPONE,
  payload,
  successCallback,
});
export const requestRejectMission = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_REJECT_MISSION,
  payload,
  successCallback,
});

export const resetStoreDetailsExpertise = () => {
  return {
    type: RESET_STORE_DETAILS_EXPERTISE,
  };
};
